(function () {
	'use strict';

	a3_cabin_reports.controller('AssignmentModalCtrl', AssignmentModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name AssignmentModalCtrl
    * @description 
    *  Manages the Assignment Modal
    * @ngInject
    */
	function AssignmentModalCtrl($scope, assignment, info, $uibModalInstance, CampaignFactory) {
		
		$scope.assignment = JSON.parse(JSON.stringify(assignment));
		$scope.info = info;
		$scope.cancel = cancel;
		$scope.submit = submit;
		$scope.giftStatus = CampaignFactory.giftStatusList();

        /**
         * Close the modal
         * @memberof AssignmentModalCtrl
         */
		function cancel() {
			$uibModalInstance.dismiss('close');
		}

		function submit() {
			CampaignFactory.updateCampaignPassenger(info.flightId, $scope.assignment);
			$uibModalInstance.close('close');
		}
	}


})();